import {
  Control,
  Controller,
  FieldPath,
  FieldValues,
  RegisterOptions,
} from 'react-hook-form';
import TextField from '../TextField/TextField';
import Select from '../Select/Select';
import React from 'react';

type InputProps =
  | AppTextFieldProps
  | AppSelectProps

export type AppControllerProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
> = InputProps & {
  inputType: ControllerVariant;
  control?: Control<TFieldValues>;
  name: TName;
  rules?: RegisterOptions<TFieldValues>;
  enableTrim?: boolean;
};

const AppController = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  inputType,
  control,
  name,
  rules,
  enableTrim,
  ...inputProps
}: AppControllerProps<TFieldValues, TName>) => (
  <Controller
    control={control}
    name={name}
    rules={rules}
    render={({ field, fieldState }) => {
      switch (inputType) {
        case 'TextField':
          return (
            <TextField
              id={name}
              variant='outlined'
              {...(inputProps as AppTextFieldProps)}
              required={!!rules?.required}
              value={field.value}
              error={fieldState.error}
              onChange={field.onChange}
              enableTrim={enableTrim}
            />
          );
          case 'Select':
            return (
              <Select
                id={name}
                {...(inputProps as AppSelectProps)}
                required={!!rules?.required}
                value={field.value}
                error={fieldState.error}
                onChange={field.onChange}
              />
            );
      }
    }}
  />
);

export default AppController;
